// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { AiOnboardingModal_EntitySuggestionFragment, AiOnboardingModal_TestamentaryEntitySuggestionFragment } from '../../../aiOnboarding/AIOnboardingModal/graphql/aiOnboardingModal.generated';
import { gql } from '@apollo/client';
import { AiOnboardingModal_EntitySuggestionFragmentDoc, AiOnboardingModal_TestamentaryEntitySuggestionFragmentDoc } from '../../../aiOnboarding/AIOnboardingModal/graphql/aiOnboardingModal.generated';
export type EstateOnboardingSuggestionsV2_AiSuggestionFragment = { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null, onboardingEntity?: (
    { __typename?: 'OnboardingEntitySuggestion' }
    & AiOnboardingModal_EntitySuggestionFragment
  ) | null, onboardingTestamentaryEntity?: (
    { __typename?: 'OnboardingTestamentaryEntitySuggestion' }
    & AiOnboardingModal_TestamentaryEntitySuggestionFragment
  ) | null, onboardingTestamentaryParentKgV2Node?: { __typename?: 'KGV2Node', id: string, namePrimary: string } | null, sourceKgV2Nodes: { __typename?: 'KGV2NodeConnection', edges?: Array<{ __typename?: 'KGV2NodeEdge', node?: { __typename?: 'KGV2Node', id: string } | null } | null> | null } };

export const Operations = {
  Fragment: {
    EstateOnboardingSuggestionsV2_AISuggestion: 'EstateOnboardingSuggestionsV2_AISuggestion' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EstateOnboardingSuggestionsV2_AiSuggestionFragmentDoc = gql`
    fragment EstateOnboardingSuggestionsV2_AISuggestion on AISuggestion {
  id
  kind
  acceptanceStatus
  onboardingEntity {
    ...AIOnboardingModal_EntitySuggestion
  }
  onboardingTestamentaryEntity {
    ...AIOnboardingModal_TestamentaryEntitySuggestion
  }
  onboardingTestamentaryParentKgV2Node {
    id
    namePrimary
  }
  sourceKgV2Nodes {
    edges {
      node {
        id
      }
    }
  }
}
    ${AiOnboardingModal_EntitySuggestionFragmentDoc}
${AiOnboardingModal_TestamentaryEntitySuggestionFragmentDoc}`;